import { createFileRoute } from "@tanstack/react-router";
import { TeamScreen } from "@modules/team/views";

interface TeamSearch {
  /** « Inviter un administrateur » from the new-cohort dialog: opens the invite dialog. */
  invite?: boolean;
}

export const Route = createFileRoute("/_staff-area/team")({
  staticData: { title: "nav.team" },
  validateSearch: (search: Record<string, unknown>): TeamSearch => ({
    invite:
      search.invite === true || search.invite === "true" ? true : undefined,
  }),
  component: TeamRoute,
});

function TeamRoute() {
  const { invite } = Route.useSearch();
  return <TeamScreen openInvite={invite === true} />;
}
